export default __webpack_public_path__ + "static/media/Matting_Dashboard_banner_3.9d611af0.jpg";